// extracted by mini-css-extract-plugin
export var rightPanelOpenOld = "_ex-0";